import React, { useState } from 'react';
import { Tooltip, message } from 'antd';
import {
  CalendarOutlined,
  CheckCircleFilled,
  CheckOutlined,
  CopyOutlined,
  DollarCircleOutlined,
  FileTextOutlined,
  IdcardOutlined,
  TrophyOutlined,
} from '@ant-design/icons';
import {
  InfoRow,
  SectionHeader,
  SideCard,
  StatusPill,
} from './HistoryDetail.styles';

const ProposalSummaryCard = ({ app }) => {
  const [copiedKey, setCopiedKey] = useState(null);

  const currentBid = Number(app?.quotedAmount || app?.bidAmount) || 0;
  const highestBid = Number(app?.highestBid) || 0;
  const isAccepted = String(app?.status || '').toLowerCase().includes('accepted');
  const isRejected = String(app?.status || '').toLowerCase().includes('rejected');
  const statusType = isAccepted ? 'accepted' : isRejected ? 'rejected' : 'pending';

  const formattedCurrent = currentBid ? `₹${currentBid.toLocaleString('en-IN')}` : 'N/A';
  const formattedHighest = highestBid ? `₹${highestBid.toLocaleString('en-IN')}` : 'N/A';

  const handleCopy = (text, key, label) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopiedKey(key);
    message.success(`${label} copied to clipboard!`);
    setTimeout(() => setCopiedKey(null), 2000);
  };

  return (
    <SideCard>
      <SectionHeader $color="#10b981">
        <div className="section-title">
          <div className="section-icon">
            <DollarCircleOutlined />
          </div>
          <span>Proposal Summary</span>
        </div>

        <StatusPill $status={statusType}>
          {statusType === 'accepted' && <CheckCircleFilled />}
          {app?.status || 'Pending'}
        </StatusPill>
      </SectionHeader>

      <InfoRow>
        <span className="info-key">
          <DollarCircleOutlined /> Quoted Bid Amount
        </span>
        <span className="info-val" style={{ color: '#059669', fontSize: 15 }}>
          {formattedCurrent}
        </span>
      </InfoRow>

      <InfoRow>
        <span className="info-key">
          <TrophyOutlined /> Highest Competing Bid
        </span>
        <span className="info-val" style={{ color: highestBid > currentBid ? '#d97706' : '#0f172a' }}>
          {formattedHighest}
        </span>
      </InfoRow>

      <InfoRow>
        <span className="info-key">
          <IdcardOutlined /> Vendor Code
        </span>
        <span className="info-val">{app?.vendorCode || '-'}</span>
      </InfoRow>

      <InfoRow>
        <span className="info-key">
          <FileTextOutlined /> Exchange Reference
        </span>
        <span className="info-val">
          {app?.exchangeReferenceId || app?.referenceNo ? (
            <Tooltip title="Click to copy Exchange Reference">
              <span
                style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 4 }}
                onClick={() => handleCopy(app.exchangeReferenceId || app.referenceNo, 'ref', 'Exchange Reference')}
              >
                #{app.exchangeReferenceId || app.referenceNo}
                {copiedKey === 'ref' ? <CheckOutlined style={{ color: '#10b981' }} /> : <CopyOutlined />}
              </span>
            </Tooltip>
          ) : (
            '-'
          )}
        </span>
      </InfoRow>

      <InfoRow>
        <span className="info-key">
          <CalendarOutlined /> Submitted On
        </span>
        <span className="info-val">{app?.bidCreatedAt || app?.date || '-'}</span>
      </InfoRow>

      <div
        style={{
          marginTop: 16,
          padding: '16px 18px',
          borderRadius: 14,
          background: isAccepted
            ? 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 50%, #d1fae5 100%)'
            : 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
          border: isAccepted ? '1px solid #a7f3d0' : '1px solid #e2e8f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
        }}
      >
        <div>
          <div style={{ fontSize: 11, fontWeight: 800, textTransform: 'uppercase', color: isAccepted ? '#047857' : '#64748b' }}>
            {isAccepted ? 'Final Accepted Valuation' : 'Net Quoted Valuation'}
          </div>
          <div style={{ fontSize: 11, color: isAccepted ? '#059669' : '#94a3b8', fontWeight: 600, marginTop: 2 }}>
            No platform deductions
          </div>
        </div>
        <div style={{ fontSize: 24, fontWeight: 900, color: isAccepted ? '#064e3b' : '#0f172a' }}>
          {formattedCurrent}
        </div>
      </div>
    </SideCard>
  );
};

export default ProposalSummaryCard;
